import { render, staticRenderFns } from "./ArtworkPreviewModal.vue?vue&type=template&id=2d2044f4&scoped=true"
import script from "./ArtworkPreviewModal.vue?vue&type=script&lang=js"
export * from "./ArtworkPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkPreviewModal.vue?vue&type=style&index=0&id=2d2044f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2044f4",
  null
  
)

export default component.exports